"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDefaultIndicatorSection = exports.buildCustomIndicatorSection = void 0;
const DefaultSubsections = require("./helpers/defaultSubsections");
function buildCustomIndicatorSection(section, schema, language = 'en') {
    const subsections = [
        {
            subtitle: schema.unit,
            dataAccessor: ['history', 'value'],
        },
        DefaultSubsections.created_at(),
        DefaultSubsections.updated_at(),
    ];
    return {
        type: 'indicator',
        description: schema.name[language] || schema.unit,
        indicator: section.indicator,
        custom: true,
        subsections,
    };
}
exports.buildCustomIndicatorSection = buildCustomIndicatorSection;
function buildDefaultIndicatorSection(section) {
    const schema = {
        type: 'indicator',
        description: section.indicator,
        indicator: section.indicator,
        custom: false,
        subsections: [
            DefaultSubsections.patientID(),
            DefaultSubsections.submissionID(),
        ],
    };
    if (section.indicator === 'activity') {
        schema.subsections = makeActivitySubsections();
    }
    else if (section.indicator === 'bloodoxygen') {
        schema.subsections = makeBloodoxygenSubsections();
    }
    else if (section.indicator === 'bloodpressure') {
        schema.subsections = makeBloodpressureSubsections();
    }
    else if (section.indicator === 'bloodsugar') {
        schema.subsections = makeBloodsugarSubsections();
    }
    else if (section.indicator === 'bodytemperature') {
        schema.subsections = makeBodytemperatureSubsections();
    }
    else if (section.indicator === 'weight') {
        schema.subsections = makeWeightSubsections();
    }
    schema.subsections = schema.subsections.concat([
        DefaultSubsections.created_at(),
        DefaultSubsections.updated_at(),
    ]);
    return schema;
}
exports.buildDefaultIndicatorSection = buildDefaultIndicatorSection;
function makeActivitySubsections() {
    return [
        {
            subtitle: 'Steps',
            dataAccessor: ['history', 'steps'],
        },
        {
            subtitle: 'Cumulative steps',
            dataAccessor: ['cumulativeSteps'],
        },
        {
            subtitle: 'Comment',
            dataAccessor: ['history', 'comment'],
        },
        {
            subtitle: 'Entered manually?',
            dataAccessor: ['history', 'manual'],
        },
    ];
}
function makeBloodoxygenSubsections() {
    return [
        {
            subtitle: 'Pulserate',
            dataAccessor: ['history', 'pulserate'],
        },
        {
            subtitle: 'Oxygen saturation',
            dataAccessor: ['history', 'oxygensaturation'],
        },
        {
            subtitle: 'Heart Rate Status',
            dataAccessor: ['history', 'heartRateStatus'],
        },
        {
            subtitle: 'Oxygen Saturation Status',
            dataAccessor: ['history', 'oxygenSaturationStatus'],
        },
        {
            subtitle: 'Comment',
            dataAccessor: ['history', 'comment'],
        },
        {
            subtitle: 'Entered manually?',
            dataAccessor: ['history', 'manual'],
        },
    ];
}
function makeBloodpressureSubsections() {
    return [
        {
            subtitle: 'Systolic value',
            dataAccessor: ['history', 'systolic'],
        },
        {
            subtitle: 'Diastolic value',
            dataAccessor: ['history', 'diastolic'],
        },
        {
            subtitle: 'Pulserate',
            dataAccessor: ['history', 'bpPulserate'],
        },
        {
            subtitle: 'Pulserate Status',
            dataAccessor: ['history', 'bpPulserateStatus'],
        },
        {
            subtitle: 'General Status',
            dataAccessor: ['history', 'status'],
        },
        {
            subtitle: 'Comment',
            dataAccessor: ['history', 'comment'],
        },
        {
            subtitle: 'Entered manually?',
            dataAccessor: ['history', 'manual'],
        },
    ];
}
function makeBloodsugarSubsections() {
    return [
        {
            subtitle: 'Mean Blood',
            dataAccessor: ['history', 'meanblood'],
        },
        {
            subtitle: 'Blood sugar (mmol/L)',
            dataAccessor: ['history', 'mmol'],
        },
        {
            subtitle: 'Blood sugar (mg/dL)',
            dataAccessor: ['history', 'mg'],
        },
        {
            subtitle: 'Entered using which units?',
            dataAccessor: ['history', 'units'],
        },
        {
            subtitle: 'Status',
            dataAccessor: ['history', 'status'],
        },
        {
            subtitle: 'Comment',
            dataAccessor: ['history', 'comment'],
        },
        {
            subtitle: 'Entered manually?',
            dataAccessor: ['history', 'manual'],
        },
    ];
}
function makeBodytemperatureSubsections() {
    return [
        {
            subtitle: 'Body temperature (Celsius)',
            dataAccessor: ['history', 'celsius'],
        },
        {
            subtitle: 'Body temperature (Fahrenheit)',
            dataAccessor: ['history', 'fahrenheit'],
        },
        {
            subtitle: 'Entered using which units?',
            dataAccessor: ['history', 'units'],
        },
        {
            subtitle: 'Status',
            dataAccessor: ['history', 'status'],
        },
        {
            subtitle: 'Comment',
            dataAccessor: ['history', 'comment'],
        },
        {
            subtitle: 'Entered manually?',
            dataAccessor: ['history', 'manual'],
        },
    ];
}
function makeWeightSubsections() {
    return [
        {
            subtitle: 'Weight (lbs)',
            dataAccessor: ['history', 'lbs'],
        },
        {
            subtitle: 'Weight (kg)',
            dataAccessor: ['history', 'kg'],
        },
        {
            subtitle: 'Entered using which units?',
            dataAccessor: ['history', 'units'],
        },
        {
            subtitle: 'Status',
            dataAccessor: ['history', 'status'],
        },
        {
            subtitle: 'Comment',
            dataAccessor: ['history', 'comment'],
        },
        {
            subtitle: 'Entered manually?',
            dataAccessor: ['history', 'manual'],
        },
    ];
}
//# sourceMappingURL=indicatorSection.js.map